export default __webpack_public_path__ + "static/media/footer-bg.13363fb4.png";